import { render, staticRenderFns } from "./FormSopimusLaskutusjaksoLisaa.vue?vue&type=template&id=59a88f7c&scoped=true&"
import script from "./FormSopimusLaskutusjaksoLisaa.vue?vue&type=script&lang=js&"
export * from "./FormSopimusLaskutusjaksoLisaa.vue?vue&type=script&lang=js&"
import style0 from "./FormSopimusLaskutusjaksoLisaa.vue?vue&type=style&index=0&id=59a88f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a88f7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDatePicker,VForm,VIcon,VMenu,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a88f7c')) {
      api.createRecord('59a88f7c', component.options)
    } else {
      api.reload('59a88f7c', component.options)
    }
    module.hot.accept("./FormSopimusLaskutusjaksoLisaa.vue?vue&type=template&id=59a88f7c&scoped=true&", function () {
      api.rerender('59a88f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusLaskutusjaksoLisaa.vue"
export default component.exports